import { graphql } from "@opensea/graphql"

export const FloorPriceSparkLineChartFragment = graphql(`
  fragment FloorPriceSparkLineChart on Collection {
    analytics {
      sparkLineSevenDay {
        price {
          token {
            unit
            symbol
          }
        }
        time
      }
    }
  }
`)
